//Copyright (c) 2022 Panshak Solomon

import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import SnackbarProvider from "react-simple-snackbar";
import Home from "./components/Home/Home";
import Invoice from "./components/Invoice/Invoice";
import Invoices from "./components/Invoices/Invoices";
import InvoiceDetails from "./components/InvoiceDetails/InvoiceDetails";
import ClientList from "./components/Clients/ClientList";
import NavBar from "./components/NavBar/NavBar";
import Login from "./components/Login/Login";
import Dashboard from "./components/Dashboard/Dashboard";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import Settings from "./components/Settings/Settings";
import Forgot from "./components/Password/Forgot";
import Reset from "./components/Password/Reset";
import ProductList from "./components/Products/ProductList";
import AssistantList from "./components/assistants/AssistantList";
import AssistantInvoices from "./components/Invoices/AssistantInvoices";
import ClientInvoices from "./components/Invoices/ClientInvoices";
import XL from "./components/xl/XL";
import AdminInvoices from "./components/Invoices/AdminInvoices";
import Checks from "./components/checks/Checks";
import DailyReportList from "./components/reports/DailyReportList";
import BillingCycleDetails from "./components/reports/BillingCycleDetails";
import BillingCycleList from "./components/reports/BillingCycleList";
import InvoicesWithRest from "./components/Invoices/InvoicesWithRest";

function App() {
  const user = JSON.parse(localStorage.getItem("profile"));

  return (
    <div>
      <BrowserRouter>
        <SnackbarProvider>
          {user && <NavBar />}
          <Header />

          <Switch>
            <Route path="/" exact component={Home} />

            <Route path="/daily-Report" exact component={DailyReportList} />
            <Route path="/invoice" exact component={Invoice} />
            <Route path="/xl" exact component={XL} />
            <Route path="/edit/invoice/:id" exact component={Invoice} />
            <Route path="/invoice/:id" exact component={InvoiceDetails} />
            <Route path="/invoices" exact component={Invoices} />
            <Route
              path="/billing-cycle/:id"
              exact
              component={BillingCycleDetails}
            />
            <Route
              path="/billing-cycle-list"
              exact
              component={BillingCycleList}
            />
            <Route path="/reports" exact component={BillingCycleList} />
            <Route path="/checks" exact component={Checks} />
            <Route path="/admin_invoices" exact component={AdminInvoices} />
            <Route path="/client-invoices" exact component={ClientInvoices} />
            <Route
              path="/product-invoices/:itemId"
              exact
              component={AssistantInvoices}
            />
            <Route
              path="/assistant-invoices/:id/:name"
              exact
              component={AssistantInvoices}
            />
            <Route path="/login" exact component={Login} />
            <Route path="/settings" exact component={Settings} />
            <Route path="/dashboard" exact component={Dashboard} />
            <Route path="/customers" exact component={ClientList} />
            <Route path="/products" exact component={ProductList} />
            <Route path="/assistants" exact component={AssistantList} />
            <Route path="/forgot" exact component={Forgot} />
            <Route path="/reset/:token" exact component={Reset} />
            <Route path="/test" exact component={InvoicesWithRest} />
            <Redirect exact from="/new-invoice" to="/invoice" />
          </Switch>
          <Footer />
        </SnackbarProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
